export default __webpack_public_path__ + "media/images/home-app-android-38d4efbc.png";